import { render, staticRenderFns } from "./FAQReview.vue?vue&type=template&id=987b8400&scoped=true&"
import script from "./FAQReview.vue?vue&type=script&lang=js&"
export * from "./FAQReview.vue?vue&type=script&lang=js&"
import style0 from "./FAQReview.vue?vue&type=style&index=0&id=987b8400&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987b8400",
  null
  
)

export default component.exports